import { useEffect, useState, useRef } from 'react';
import LandingPage from './LandingPage';
import About    from './About';
import Services from './Services';
import Blog     from './Blog';
import Support  from './Support';
import Contact  from './Contact';

/* ── SVG Social Icons ── */
const IconFacebook = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="6" fill="#1877F2"/>
    <path d="M16 8h-2a1 1 0 0 0-1 1v2h3l-.5 3H13v7h-3v-7H8v-3h2V9a4 4 0 0 1 4-4h2v3z" fill="#fff"/>
  </svg>
);
const IconTwitter = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="6" fill="#000"/>
    <path d="M17.5 5h-2.3l-3.2 4.2L8.8 5H4.5l5.5 7.3L4.5 19h2.3l3.5-4.6L13.8 19h4.3l-5.8-7.7L17.5 5z" fill="#fff"/>
  </svg>
);
const IconInstagram = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <defs>
      <linearGradient id="ig" x1="0" y1="24" x2="24" y2="0" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#f09433"/>
        <stop offset="25%" stopColor="#e6683c"/>
        <stop offset="50%" stopColor="#dc2743"/>
        <stop offset="75%" stopColor="#cc2366"/>
        <stop offset="100%" stopColor="#bc1888"/>
      </linearGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#ig)"/>
    <rect x="7" y="7" width="10" height="10" rx="3" stroke="#fff" strokeWidth="1.8" fill="none"/>
    <circle cx="12" cy="12" r="2.5" stroke="#fff" strokeWidth="1.8" fill="none"/>
    <circle cx="17" cy="7" r="1" fill="#fff"/>
  </svg>
);
const IconLinkedIn = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="6" fill="#0A66C2"/>
    <path d="M7 10h2v7H7v-7zm1-3a1.2 1.2 0 1 1 0 2.4A1.2 1.2 0 0 1 8 7zm4 3h2v1h.03C14.4 10.4 15.2 10 16 10c2 0 2.5 1.3 2.5 3v4h-2v-3.5c0-.8 0-1.9-1.2-1.9-1.2 0-1.3.9-1.3 1.8V17h-2v-7z" fill="#fff"/>
  </svg>
);
const IconWhatsApp = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="6" fill="#25D366"/>
    <path d="M12 4a8 8 0 0 0-6.93 12L4 20l4.17-1.05A8 8 0 1 0 12 4zm0 14.5a6.47 6.47 0 0 1-3.3-.9l-.24-.14-2.47.62.65-2.4-.16-.25A6.5 6.5 0 1 1 12 18.5zm3.56-4.87c-.2-.1-1.17-.57-1.35-.64-.18-.07-.31-.1-.44.1-.13.2-.5.64-.62.77-.11.13-.23.14-.43.05-.2-.1-.83-.3-1.59-.96-.59-.52-.98-1.16-1.1-1.36-.11-.2-.01-.31.08-.4l.4-.46c.1-.12.13-.2.2-.33.07-.13.03-.25-.02-.34-.05-.1-.44-1.06-.6-1.45-.16-.38-.32-.33-.44-.33h-.37c-.13 0-.34.05-.52.25-.18.2-.68.66-.68 1.6s.7 1.86.8 1.99c.1.13 1.38 2.1 3.34 2.95.47.2.83.32 1.12.41.47.15.9.13 1.23.08.38-.06 1.17-.48 1.33-.94.16-.46.16-.86.11-.94-.05-.08-.18-.13-.38-.23z" fill="#fff"/>
  </svg>
);
const IconTelegram = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="6" fill="#26A5E4"/>
    <path d="M5.5 11.5l12-5c.6-.2 1.1.1.9.8l-2 9.5c-.1.6-.6.8-1 .5l-3-2.3-1.4 1.4c-.2.2-.4.2-.5 0L9 13.5l-3.5-1c-.6-.2-.6-.7 0-1z" fill="#fff"/>
  </svg>
);
const IconYouTube = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="6" fill="#FF0000"/>
    <path d="M19.6 8s-.2-1.3-.8-1.9c-.7-.8-1.5-.8-1.9-.8C14.8 5.2 12 5.2 12 5.2s-2.8 0-4.9.1c-.4 0-1.2.1-1.9.8-.6.6-.8 1.9-.8 1.9S4.2 9.4 4.2 11v1.5c0 1.5.2 3 .2 3s.2 1.3.8 1.9c.7.8 1.7.7 2.1.8C8.6 18.3 12 18.4 12 18.4s2.8 0 4.9-.2c.4 0 1.2-.1 1.9-.8.6-.6.8-1.9.8-1.9s.2-1.5.2-3V11c0-1.5-.2-3-.2-3z" fill="#FF0000"/>
    <path d="M10.2 14.5V9.8l5.2 2.4-5.2 2.3z" fill="#fff"/>
  </svg>
);

const SOCIAL_LINKS = [
  { Icon: IconFacebook, url: 'https://facebook.com/digitalagency',            label: 'Facebook'  },
  { Icon: IconTwitter,  url: 'https://twitter.com/digitalagency',             label: 'Twitter'   },
  { Icon: IconInstagram,url: 'https://instagram.com/digital.agency',          label: 'Instagram' },
  { Icon: IconLinkedIn, url: 'https://linkedin.com/company/digital-agency',   label: 'LinkedIn'  },
  { Icon: IconWhatsApp, url: 'https://wa.me/919999999999',                    label: 'WhatsApp'  },
  { Icon: IconTelegram, url: 'https://t.me/digitalagency',                    label: 'Telegram'  },
];

/* ── WhatsApp Chatbot Widget ── */
const BOT_NAME    = 'Digital Agency';
const BOT_NUMBER  = '919999999999'; // replace with your WhatsApp number

const BOT_REPLIES = [
  {
    match: ['hi','hello','hey','hii','helo'],
    reply: "Hi there! 👋 Welcome to Digital Agency. How can I help you today?\n\nChoose an option:\n1️⃣ Our Services\n2️⃣ Pricing\n3️⃣ Contact Us\n4️⃣ Talk to a Human",
  },
  {
    match: ['service','services','what do you do','offerings','1'],
    reply: "We offer full-stack digital marketing:\n\n🔍 SEO & Organic Growth\n🎯 Paid Ads (Google, Meta)\n📱 Social Media Marketing\n✍️ Content Marketing\n📧 Email Campaigns\n📊 Analytics & Reporting\n\nWant details on any service?",
  },
  {
    match: ['price','pricing','cost','how much','rate','rates','charges','2'],
    reply: "Our pricing is flexible based on your goals:\n\n📦 Starter — ₹15,000/mo\n📦 Growth — ₹35,000/mo\n📦 Enterprise — Custom\n\nAll plans include a dedicated account manager & monthly reports. Want a free consultation?",
  },
  {
    match: ['contact','reach','call','phone','email','3'],
    reply: "You can reach us at:\n\n📧 hello@digitalagency.in\n📞 +91 99999 99999\n🕐 Mon–Fri, 9AM–7PM IST\n\nOr scroll down to our Contact section to send a message directly!",
  },
  {
    match: ['human','agent','person','talk','speak','support','4'],
    reply: "Sure! I'll connect you with our team on WhatsApp right now. 🙌",
    redirect: true,
  },
  {
    match: ['seo','search','google ranking','organic'],
    reply: "Our SEO service covers:\n\n✅ Technical SEO audit\n✅ Keyword research & strategy\n✅ On-page optimisation\n✅ Link building\n✅ Monthly ranking reports\n\nMost clients see results in 3–6 months. Want to get started?",
  },
  {
    match: ['ads','paid','ppc','meta','facebook ads','google ads'],
    reply: "We manage Paid Ads across:\n\n🎯 Google Search & Display\n🎯 Meta (Facebook + Instagram)\n🎯 LinkedIn Ads\n🎯 YouTube Ads\n\nMinimum recommended ad spend: ₹30,000/month. ROI-focused campaigns only. Interested?",
  },
  {
    match: ['social media','instagram','linkedin','twitter','social'],
    reply: "Our Social Media service includes:\n\n📅 Content calendar & creation\n💬 Community management\n📈 Growth strategy\n🤝 Influencer outreach\n📊 Monthly analytics report\n\nWe manage all major platforms. Want to know more?",
  },
  {
    match: ['thanks','thank you','thankyou','ok','okay','great','perfect','nice'],
    reply: "You're welcome! 😊 Is there anything else I can help you with? Feel free to ask anytime.",
  },
];

const DEFAULT_REPLY = "I didn't quite catch that 😅 Try asking about:\n\n• Our Services\n• Pricing\n• SEO / Paid Ads / Social Media\n• Contact details\n\nOr type *4* to talk to a human!";

function getReply(text) {
  const lower = text.toLowerCase().trim();
  for (const item of BOT_REPLIES) {
    if (item.match.some(k => lower.includes(k))) return item;
  }
  return { reply: DEFAULT_REPLY };
}

function WhatsAppChatbot() {
  const [open, setOpen]       = useState(false);
  const [messages, setMessages] = useState([
    { from: 'bot', text: "Hi! 👋 I'm the Digital Agency assistant.\n\nHow can I help you today?\n\n1️⃣ Our Services\n2️⃣ Pricing\n3️⃣ Contact Us\n4️⃣ Talk to a Human" }
  ]);
  const [input, setInput]     = useState('');
  const [typing, setTyping]   = useState(false);
  const bottomRef             = useRef(null);

  useEffect(() => {
    if (bottomRef.current) bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [messages, typing]);

  const send = (text) => {
    const userText = text || input;
    if (!userText.trim()) return;
    setInput('');
    setMessages(prev => [...prev, { from: 'user', text: userText }]);
    setTyping(true);
    setTimeout(() => {
      const result = getReply(userText);
      setTyping(false);
      setMessages(prev => [...prev, { from: 'bot', text: result.reply }]);
      if (result.redirect) {
        setTimeout(() => {
          const waUrl = `https://wa.me/${BOT_NUMBER}?text=${encodeURIComponent('Hi! I came from your website and would like to speak with your team.')}`;
          window.open(waUrl, '_blank');
        }, 800);
      }
    }, 900);
  };

  const handleKey = (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } };

  return (
    <>
      <style>{`
        @keyframes wa-pulse { 0%{box-shadow:0 0 0 0 rgba(37,211,102,0.65)} 70%{box-shadow:0 0 0 16px rgba(37,211,102,0)} 100%{box-shadow:0 0 0 0 rgba(37,211,102,0)} }
        @keyframes wa-pop   { 0%{transform:scale(0.5);opacity:0} 70%{transform:scale(1.08)} 100%{transform:scale(1);opacity:1} }
        @keyframes wa-slide { 0%{transform:translateY(20px) scale(0.96);opacity:0} 100%{transform:translateY(0) scale(1);opacity:1} }
        .wa-fab {
          position:fixed; bottom:28px; right:24px; z-index:9999;
          width:60px; height:60px; border-radius:50%; background:#25D366; border:3px solid #fff;
          display:flex; align-items:center; justify-content:center; cursor:pointer;
          box-shadow:0 6px 24px rgba(37,211,102,0.55),0 2px 8px rgba(0,0,0,0.2);
          animation:wa-pulse 2.2s ease-out infinite;
          transition:transform 0.2s;
        }
        .wa-fab:hover { transform:scale(1.1); animation:none; box-shadow:0 10px 32px rgba(37,211,102,0.7); }
        .wa-fab-dot { position:absolute; top:2px; right:2px; width:13px; height:13px; background:#4ade80; border-radius:50%; border:2px solid #fff; }
        .wa-box {
          position:fixed; bottom:102px; right:24px; z-index:9998;
          width:340px; border-radius:20px; overflow:hidden;
          box-shadow:0 16px 48px rgba(0,0,0,0.2),0 4px 16px rgba(0,0,0,0.12);
          animation:wa-slide 0.3s cubic-bezier(.34,1.56,.64,1) forwards;
          font-family:'Space Mono',monospace;
        }
        .wa-header {
          background:linear-gradient(135deg,#25D366,#128C7E);
          padding:16px 18px; display:flex; align-items:center; gap:12px;
        }
        .wa-avatar {
          width:42px; height:42px; border-radius:50%; background:rgba(255,255,255,0.2);
          display:flex; align-items:center; justify-content:center; font-size:20px; flex-shrink:0;
        }
        .wa-header-name { font-size:13px; font-weight:700; color:#fff; letter-spacing:0.04em; }
        .wa-header-status { font-size:10px; color:rgba(255,255,255,0.75); margin-top:2px; display:flex; align-items:center; gap:5px; }
        .wa-status-dot { width:7px; height:7px; background:#4ade80; border-radius:50%; }
        .wa-close { margin-left:auto; background:none; border:none; color:#fff; font-size:18px; cursor:pointer; opacity:0.8; padding:0; line-height:1; }
        .wa-close:hover { opacity:1; }
        .wa-msgs {
          background:#ECE5DD; padding:14px 12px;
          height:300px; overflow-y:auto; display:flex; flex-direction:column; gap:8px;
          background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23c9b99a' fill-opacity='0.15'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }
        .wa-msgs::-webkit-scrollbar { width:4px; }
        .wa-msgs::-webkit-scrollbar-thumb { background:rgba(0,0,0,0.15); border-radius:4px; }
        .wa-bubble { max-width:82%; padding:9px 12px; border-radius:12px; font-size:11px; line-height:1.7; white-space:pre-wrap; word-break:break-word; }
        .wa-bubble.bot  { background:#fff; color:#1a1a1a; border-top-left-radius:2px; align-self:flex-start; box-shadow:0 1px 2px rgba(0,0,0,0.1); }
        .wa-bubble.user { background:#DCF8C6; color:#1a1a1a; border-top-right-radius:2px; align-self:flex-end; box-shadow:0 1px 2px rgba(0,0,0,0.1); }
        .wa-typing { display:flex; gap:4px; align-items:center; padding:10px 12px; background:#fff; border-radius:12px; border-top-left-radius:2px; align-self:flex-start; box-shadow:0 1px 2px rgba(0,0,0,0.1); }
        .wa-typing span { width:7px; height:7px; background:#999; border-radius:50%; animation:wa-dot 1.2s ease-in-out infinite; }
        .wa-typing span:nth-child(2) { animation-delay:0.2s; }
        .wa-typing span:nth-child(3) { animation-delay:0.4s; }
        @keyframes wa-dot { 0%,60%,100%{transform:translateY(0)} 30%{transform:translateY(-5px)} }
        .wa-quick { background:#fff; padding:10px 12px; display:flex; gap:6px; flex-wrap:wrap; border-top:1px solid #e0e0e0; }
        .wa-quick-btn { font-size:9px; font-weight:700; letter-spacing:0.06em; background:#f0f9f4; color:#128C7E; border:1px solid #b2dfdb; border-radius:20px; padding:5px 10px; cursor:pointer; white-space:nowrap; transition:background 0.15s; font-family:'Space Mono',monospace; }
        .wa-quick-btn:hover { background:#128C7E; color:#fff; border-color:#128C7E; }
        .wa-input-row { background:#fff; padding:10px 12px; display:flex; gap:8px; align-items:center; border-top:1px solid #e0e0e0; }
        .wa-input { flex:1; border:1px solid #e0e0e0; border-radius:20px; padding:8px 14px; font-size:11px; font-family:'Space Mono',monospace; outline:none; resize:none; background:#f9f9f9; color:#1a1a1a; }
        .wa-input:focus { border-color:#25D366; background:#fff; }
        .wa-send { width:36px; height:36px; border-radius:50%; background:#25D366; border:none; cursor:pointer; display:flex; align-items:center; justify-content:center; flex-shrink:0; transition:background 0.15s; }
        .wa-send:hover { background:#128C7E; }
        .wa-notice { font-size:9px; color:#888; text-align:center; padding:6px 12px 10px; background:#fff; letter-spacing:0.06em; }
      `}</style>

      {/* Chat box */}
      {open && (
        <div className="wa-box">
          <div className="wa-header">
            <div className="wa-avatar">🤖</div>
            <div>
              <div className="wa-header-name">{BOT_NAME}</div>
              <div className="wa-header-status"><span className="wa-status-dot" />Online — replies instantly</div>
            </div>
            <button className="wa-close" onClick={() => setOpen(false)}>✕</button>
          </div>

          <div className="wa-msgs">
            {messages.map((m, i) => (
              <div key={i} className={`wa-bubble ${m.from}`}>{m.text}</div>
            ))}
            {typing && (
              <div className="wa-typing">
                <span /><span /><span />
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          {/* Quick reply buttons */}
          <div className="wa-quick">
            {['Services', 'Pricing', 'Contact', 'Talk to Human'].map(q => (
              <button key={q} className="wa-quick-btn" onClick={() => send(q)}>{q}</button>
            ))}
          </div>

          {/* Input */}
          <div className="wa-input-row">
            <input
              className="wa-input"
              placeholder="Type a message..."
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKey}
            />
            <button className="wa-send" onClick={() => send()}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          <div className="wa-notice">Powered by Digital Agency · WhatsApp: +91 99999 99999</div>
        </div>
      )}

      {/* FAB button */}
      <div className="wa-fab" onClick={() => setOpen(o => !o)}>
        <div className="wa-fab-dot" />
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
          <path d="M12 2a10 10 0 0 0-8.49 15.26L2 22l4.89-1.48A10 10 0 1 0 12 2zm0 18.18a8.18 8.18 0 0 1-4.16-1.13l-.3-.18-3.1.93.97-3-.2-.31A8.18 8.18 0 1 1 12 20.18zM16.9 14.4c-.25-.12-1.47-.72-1.7-.8-.23-.09-.39-.12-.56.12-.17.25-.64.8-.78.96-.14.17-.28.19-.53.06-.25-.12-1.05-.39-2-.12-.74-.34-1.24-.73-1.38-1.08-.14-.25-.01-.39.11-.51.11-.11.25-.28.37-.42.13-.14.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.77-1.84-.2-.48-.4-.42-.56-.42h-.47c-.17 0-.43.06-.65.31-.22.25-.85.83-.85 2.02s.87 2.35 1 2.51c.12.17 1.72 2.63 4.17 3.69.58.25 1.04.4 1.4.51.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.68-1.19.21-.58.21-1.08.14-1.19-.06-.1-.23-.16-.48-.28z" fill="#fff"/>
        </svg>
      </div>
    </>
  );
}

/* ── Fixed Left Social Sidebar ── */
function SocialSidebar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const homeSection = document.getElementById('home');
    const onScroll = () => {
      const heroBottom = homeSection ? homeSection.offsetHeight : window.innerHeight;
      setVisible(window.scrollY > heroBottom - 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div style={{
      position: 'fixed', left: 16, top: '50%', transform: 'translateY(-50%)',
      zIndex: 999, display: 'flex', flexDirection: 'column', gap: 8,
      opacity: visible ? 1 : 0, pointerEvents: visible ? 'all' : 'none',
      transition: 'opacity 0.4s ease',
    }}>
      <div style={{
        background: '#fff', borderRadius: 14, padding: '10px 8px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.08)',
        display: 'flex', flexDirection: 'column', gap: 8,
        border: '1px solid rgba(0,0,0,0.06)',
      }}>
        {SOCIAL_LINKS.map(({ Icon, url, label }) => (
          <a key={label} href={url} target="_blank" rel="noopener noreferrer"
            title={label}
            style={{
              width: 36, height: 36, borderRadius: 8,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'transform 0.2s, box-shadow 0.2s',
              textDecoration: 'none',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.18)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)';    e.currentTarget.style.boxShadow = 'none'; }}
          >
            <Icon />
          </a>
        ))}
      </div>
    </div>
  );
}

/* ── Testimonials ── */
const PER_PAGE = 3;
const TESTIMONIALS = [
  {
    name: 'Rahul Mehta',
    role: 'Founder & CEO',
    company: 'Zephyr Fintech',
    avatar: 'RM',
    avatarBg: '#1B2FE8',
    stars: 5,
    quote: 'Digital Agency tripled our organic traffic in just 4 months. Their SEO strategy was data-driven and the results were beyond what we expected. Our cost-per-lead dropped by 60%.',
    metric: '3× Traffic',
    metricLabel: 'in 4 months',
  },
  {
    name: 'Sneha Patel',
    role: 'Marketing Director',
    company: 'Bloom Wellness',
    avatar: 'SP',
    avatarBg: '#7C3AED',
    stars: 5,
    quote: 'We launched a Google Ads campaign with them and saw 4.2× ROI within the first month. The team is incredibly responsive and transparent — no hidden fees, no fluff.',
    metric: '4.2× ROI',
    metricLabel: 'from paid ads',
  },
  {
    name: 'Arjun Krishnan',
    role: 'Co-Founder',
    company: 'NovaBuild Tech',
    avatar: 'AK',
    avatarBg: '#059669',
    stars: 5,
    quote: 'From zero to 12,000 Instagram followers in 3 months. Their content strategy and community management is top-notch. We\'ve seen real business impact from social media for the first time.',
    metric: '12K Followers',
    metricLabel: 'in 3 months',
  },
  {
    name: 'Divya Rajan',
    role: 'E-commerce Manager',
    company: 'StyleNest',
    avatar: 'DR',
    avatarBg: '#DC2626',
    stars: 5,
    quote: 'Our email campaigns now have a 42% open rate — industry average is 21%. The segmentation and copy they write actually converts. Best marketing investment we\'ve made.',
    metric: '42% Open Rate',
    metricLabel: 'vs 21% avg',
  },
  {
    name: 'Vikram Desai',
    role: 'Head of Growth',
    company: 'CloudStack SaaS',
    avatar: 'VD',
    avatarBg: '#D97706',
    stars: 5,
    quote: 'They managed our entire content pipeline — blogs, case studies, LinkedIn posts. Our domain authority jumped from 22 to 58 in 6 months and inbound leads doubled.',
    metric: 'DA 22 → 58',
    metricLabel: 'in 6 months',
  },
  {
    name: 'Priya Nambiar',
    role: 'Brand Manager',
    company: 'EcoVibe FMCG',
    avatar: 'PN',
    avatarBg: '#0891B2',
    stars: 5,
    quote: 'Professional, creative, and results-focused. Our brand awareness campaigns reached 2 million people with a CPM that beat every previous agency we\'d worked with. Highly recommend.',
    metric: '2M+ Reached',
    metricLabel: 'brand campaign',
  },
];

function StarRow({ count }) {
  return (
    <div style={{ display: 'flex', gap: 3 }}>
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="13" height="13" viewBox="0 0 24 24" fill="#FBBF24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ))}
    </div>
  );
}

const TOTAL_PAGES = Math.ceil(TESTIMONIALS.length / PER_PAGE);

function Testimonials() {
  const [page, setPage] = useState(0);
  const [dir, setDir] = useState(1);
  const [animKey, setAnimKey] = useState(0);
  const timerRef = useRef(null);

  const goTo = (nextPage, direction) => {
    clearInterval(timerRef.current);
    setDir(direction);
    setAnimKey(k => k + 1);
    setPage(nextPage);
    timerRef.current = setInterval(() => advance(), 5000);
  };

  const advance = () => {
    setDir(1);
    setAnimKey(k => k + 1);
    setPage(p => (p + 1) % TOTAL_PAGES);
  };

  useEffect(() => {
    timerRef.current = setInterval(advance, 5000);
    return () => clearInterval(timerRef.current);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cards = TESTIMONIALS.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);

  return (
    <>
      <style>{`
        @keyframes tm-slide-in-right  { from{opacity:0;transform:translateX(60px)}  to{opacity:1;transform:translateX(0)} }
        @keyframes tm-slide-in-left   { from{opacity:0;transform:translateX(-60px)} to{opacity:1;transform:translateX(0)} }
        @keyframes tm-shimmer { 0%{left:-70%} 100%{left:120%} }
        .tm-section {
          background: #F5F2EC;
          padding: 72px 40px 64px;
          font-family: 'Space Mono', monospace;
        }
        .tm-inner { max-width: 1100px; margin: 0 auto; }
        .tm-header { text-align: center; margin-bottom: 40px; }
        .tm-label {
          font-size: 9px; letter-spacing: 0.32em; text-transform: uppercase;
          color: #1B2FE8; margin-bottom: 10px;
        }
        .tm-heading {
          font-family: 'Bebas Neue', monospace;
          font-size: clamp(34px, 4.5vw, 54px);
          letter-spacing: 0.12em;
          color: #1a1a1a;
          line-height: 1;
          margin-bottom: 8px;
        }
        .tm-sub { font-size: 10px; color: #999; letter-spacing: 0.1em; }
        .tm-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          margin-bottom: 32px;
          animation: tm-slide-in-right 0.45s cubic-bezier(.22,.68,0,1.2) both;
        }
        .tm-grid.left { animation-name: tm-slide-in-left; }
        .tm-card {
          background: #fff;
          border-radius: 16px;
          padding: 28px 26px 24px;
          border: 1px solid #E8E4DC;
          box-shadow: 0 2px 16px rgba(0,0,0,0.06);
          position: relative;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          gap: 14px;
          transition: transform 0.22s, box-shadow 0.22s;
        }
        .tm-card:hover { transform: translateY(-4px); box-shadow: 0 8px 28px rgba(0,0,0,0.1); }
        .tm-card::after {
          content:'';
          position:absolute;
          top:0; left:-70%; width:40%; height:100%;
          background:linear-gradient(90deg,transparent,rgba(255,255,255,0.6),transparent);
          animation: tm-shimmer 2.8s ease-in-out infinite;
        }
        .tm-qmark {
          font-family: Georgia, serif;
          font-size: 52px;
          line-height: 0.7;
          color: rgba(27,47,232,0.18);
          margin-bottom: 2px;
        }
        .tm-quote {
          font-size: 11px;
          line-height: 1.9;
          color: #555;
          letter-spacing: 0.03em;
          flex: 1;
        }
        .tm-divider { height: 1px; background: #F0EDE8; }
        .tm-author { display: flex; align-items: center; gap: 12px; }
        .tm-avatar {
          width: 42px; height: 42px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 12px; font-weight: 700; color: #fff;
          letter-spacing: 0.05em; flex-shrink: 0;
        }
        .tm-name { font-size: 10px; font-weight: 700; color: #1a1a1a; letter-spacing: 0.07em; margin-bottom: 2px; }
        .tm-role { font-size: 8px; color: #aaa; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 5px; }
        .tm-metric {
          margin-left: auto; text-align: right;
        }
        .tm-metric-num { font-size: 13px; font-weight: 700; color: #1B2FE8; letter-spacing: 0.05em; }
        .tm-metric-lbl { font-size: 7px; color: #bbb; letter-spacing: 0.1em; text-transform: uppercase; }
        .tm-footer { display: flex; align-items: center; justify-content: center; gap: 12px; }
        .tm-arrow {
          width: 36px; height: 36px; border-radius: 50%;
          background: #fff; border: 1px solid #DDD9D0;
          color: #555; font-size: 15px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: background 0.18s, border-color 0.18s, color 0.18s;
          box-shadow: 0 1px 6px rgba(0,0,0,0.07);
        }
        .tm-arrow:hover { background: #1B2FE8; border-color: #1B2FE8; color: #fff; }
        .tm-dots { display: flex; gap: 7px; align-items: center; }
        .tm-dot {
          width: 7px; height: 7px; border-radius: 4px;
          background: #D5D0C8; cursor: pointer;
          transition: background 0.3s, width 0.3s;
        }
        .tm-dot.active { width: 24px; background: #1B2FE8; }
        @media (max-width: 860px) {
          .tm-grid { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 560px) {
          .tm-grid { grid-template-columns: 1fr; }
          .tm-section { padding: 52px 20px 48px; }
        }
      `}</style>

      <section className="tm-section">
        <div className="tm-inner">

          <div className="tm-header">
            <div className="tm-label">Client Reviews</div>
            <div className="tm-heading">WHAT CLIENTS SAY</div>
            <div className="tm-sub">Real results. Real businesses. Real growth.</div>
          </div>

          <div className={`tm-grid${dir < 0 ? ' left' : ''}`} key={animKey}>
            {cards.map((t, i) => (
              <div className="tm-card" key={i}>
                <div className="tm-qmark">"</div>
                <div className="tm-quote">{t.quote}</div>
                <div className="tm-divider" />
                <div className="tm-author">
                  <div className="tm-avatar" style={{ background: t.avatarBg }}>{t.avatar}</div>
                  <div>
                    <div className="tm-name">{t.name}</div>
                    <div className="tm-role">{t.role} · {t.company}</div>
                    <StarRow count={t.stars} />
                  </div>
                  <div className="tm-metric">
                    <div className="tm-metric-num">{t.metric}</div>
                    <div className="tm-metric-lbl">{t.metricLabel}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="tm-footer">
            <button className="tm-arrow" onClick={() => goTo((page - 1 + TOTAL_PAGES) % TOTAL_PAGES, -1)}>←</button>
            <div className="tm-dots">
              {Array.from({ length: TOTAL_PAGES }).map((_, i) => (
                <div key={i} className={`tm-dot${i === page ? ' active' : ''}`} onClick={() => goTo(i, i > page ? 1 : -1)} />
              ))}
            </div>
            <button className="tm-arrow" onClick={() => goTo((page + 1) % TOTAL_PAGES, 1)}>→</button>
          </div>

        </div>
      </section>
    </>
  );
}

function App() {
  return (
    <div className="App">

      {/* Fixed left social sidebar — hidden on home section */}
      <SocialSidebar />

      {/* WhatsApp floating chat button — visible on every section */}
      <WhatsAppChatbot />

      {/* HOME */}
      <section id="home">
        <LandingPage />
      </section>

      {/* ABOUT */}
      <section id="about">
        <About />
      </section>

      {/* SUPPORT */}
      <section id="support">
        <Support />
      </section>

      {/* SERVICES */}
      <section id="services">
        <Services />
      </section>

      {/* BLOG */}
      <section id="blog">
        <Blog />
      </section>

      {/* CONTACT */}
      <section id="contact">
        <Contact />
      </section>

      {/* TESTIMONIALS */}
      <Testimonials />

      {/* FOOTER */}
      <footer style={{
        background: '#F4F1EB',
        borderTop: '1px solid #DDD9D0',
        padding: '64px 40px 40px',
        fontFamily: "'Space Mono', monospace",
      }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>

          {/* Top row */}
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 40, marginBottom: 48 }}>
            <div>
              <div style={{ fontFamily: "'Bebas Neue', monospace", fontSize: 32, letterSpacing: '0.12em', color: '#1a1a1a', marginBottom: 12 }}>
                DIGITAL AGENCY
              </div>
              <p style={{ fontSize: 10, lineHeight: 1.9, color: '#888', letterSpacing: '0.08em', maxWidth: 260 }}>
                Full-stack digital marketing for brands that want to grow — not just be visible.
              </p>
            </div>
            <div style={{ display: 'flex', gap: 60, flexWrap: 'wrap' }}>
              {[
                { heading: 'Services', links: ['SEO & Growth', 'Paid Advertising', 'Social Media', 'Content Marketing', 'Email Campaigns'] },
                { heading: 'Company',  links: ['About Us', 'Blog', 'Case Studies', 'Careers', 'Contact'] },
                { heading: 'Legal',    links: ['Privacy Policy', 'Terms of Use', 'Cookie Policy'] },
              ].map(col => (
                <div key={col.heading}>
                  <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.28em', textTransform: 'uppercase', color: '#bbb', marginBottom: 16 }}>
                    {col.heading}
                  </div>
                  {col.links.map(l => (
                    <a key={l} href="#" style={{ display: 'block', fontSize: 10, letterSpacing: '0.08em', color: '#888', textDecoration: 'none', marginBottom: 10, transition: 'color 0.2s' }}
                      onMouseEnter={e => e.target.style.color = '#1B2FE8'}
                      onMouseLeave={e => e.target.style.color = '#888'}
                    >{l}</a>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div style={{ height: 1, background: '#DDD9D0', marginBottom: 28 }} />

          {/* Bottom row */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
            <p style={{ fontSize: 9, letterSpacing: '0.14em', color: '#aaa', textTransform: 'uppercase' }}>
              © 2026 Digital Agency · All rights reserved
            </p>
            <div style={{ display: 'flex', gap: 10 }}>
              {SOCIAL_LINKS.map(({ Icon, url, label }) => (
                <a key={label} href={url} target="_blank" rel="noopener noreferrer"
                  title={label}
                  style={{
                    width: 36, height: 36, borderRadius: 8,
                    border: '1px solid #DDD9D0', background: '#fff',
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)';    e.currentTarget.style.boxShadow = 'none'; }}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

        </div>
      </footer>

    </div>
  );
}

export default App;